import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=f8b1deb8&scoped=true&"
import script from "./ImagePreview.vue?vue&type=script&lang=js&"
export * from "./ImagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b1deb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8b1deb8')) {
      api.createRecord('f8b1deb8', component.options)
    } else {
      api.reload('f8b1deb8', component.options)
    }
    module.hot.accept("./ImagePreview.vue?vue&type=template&id=f8b1deb8&scoped=true&", function () {
      api.rerender('f8b1deb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/ImagePreview.vue"
export default component.exports